<template>
    <div class="home">
        <div class="home_lbt">
            <el-carousel height="800px" style="width: 100%">
                <el-carousel-item v-for="item in imglist" :key="item.id">
                    <img :src="item.networkUrl" alt="" />
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="home_navigation" style="font-size: 26px">
            <div @click="tolist(3, 20)">
                <i class="iconfont">&#xe61c;</i>
                <p :style="icon">挂号流程</p>
            </div>
            <div @click="tolist(3, 22)">
                <i class="iconfont">&#xe859;</i>
                <p :style="icon">就医须知</p>
            </div>
            <div @click="tolist(3, 26)">
                <i class="iconfont">&#xe610;</i>
                <p :style="icon">医保政策</p>
            </div>
            <div @click="map">
                <i class="iconfont">&#xe60d;</i>
                <p :style="icon">医院导航</p>
            </div>
            <div @click="tolist(3, 24)">
                <i class="iconfont">&#xe68c;</i>
                <p :style="icon">科室导航</p>
            </div>
            <div @click="tolist(10, 51)">
                <i class="iconfont">&#xe693;</i>
                <p :style="icon">专题专栏</p>
            </div>
        </div>
        <div class="gkdt">
            <div style="width: 49%">
                <div class="home_title">
                    <div class="title">医院概况</div>
                    <div class="ckgd" @click="tolist(1, 11)">+查看更多</div>
                </div>
                <div class="yygkbox" @click="tolist(1, 11)">
                    <div class="yygkimg"><img :src="synopsisimg" alt="" /></div>
                    <div class="yygktext" v-html="synopsis"></div>
                </div>
            </div>
            <div style="width: 49%">
                <div class="home_title">
                    <div class="title">行业新闻</div>
                    <div class="ckgd" @click="tolist(2, 19)">+查看更多</div>
                </div>
                <div class="yydtbox">
                    <div class="yydtimg"><img :src="dynamicimg" alt="" /></div>
                    <div class="yydttext">
                        <div
                            class="ul"
                            v-for="item in dynamic"
                            ::key="item.id"
                            @click="todetails(item.id)"
                        >
                            <div class="ultitle">{{ item.title }}</div>
                            <div class="ulitem">{{ item.createTime.slice(0, 10) }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="yygg">
            <div class="home_title">
                <div class="title">医院公告</div>
                <div class="ckgd" @click="tolist(6, 36)">+查看更多</div>
            </div>
            <div class="yygg_b">
                <div
                    class="yyggbox"
                    v-for="item in notice"
                    :key="item.id"
                    @click="todetails(item.id)"
                >
                    <div class="timebox">
                        <p class="ny" :style="ny">{{ item.createTime.slice(0, 7) }}</p>
                        <p class="r">{{ item.createTime.slice(8, 10) }}</p>
                    </div>
                    <div class="text_box">
                        <p>
                            {{ item.title }}
                        </p>
                        <div class="text_ti">
                            <p>{{ item.writer }}</p>
                            <i class="el-icon-sort-up"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="xwzx">
            <div class="home_title">
                <div class="title">新闻中心</div>
                <div class="ckgd" @click="tolist(2, 17)">+查看更多</div>
            </div>
            <div class="xwzx_box">
                <div
                    class="xwzx_b"
                    v-for="item in newslist"
                    :key="item.id"
                    @click="todetails(item.id)"
                >
                    <div class="xwzx_img"><img :src="item.coverUrl" alt="" /></div>
                    <div class="time">
                        <div>
                            <span style="font-size: 30px">{{ item.createTime.slice(8, 10) }}</span>
                            <span>/{{ item.createTime.slice(0, 7) }}</span>
                        </div>
                        <i class="el-icon-plus"></i>
                    </div>
                    <p>{{ item.title }}</p>
                </div>
            </div>
        </div>

        <div class="zjjs">
            <div class="home_title">
                <div class="title">专家介绍</div>
                <div class="ckgd">
                    <el-select v-model="ks" placeholder="选择科室" :clearable="true">
                        <el-option
                            v-for="item in kslist"
                            ::key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                    <el-button
                        @click="btnzj"
                        style="background-color: #279f99; color: #fff; margin-left: 20px"
                        icon="el-icon-search"
                    >
                        专家查询
                    </el-button>
                    <div @click="experts">+查看更多</div>
                </div>
            </div>
            <div class="zjjs_box">
                <el-carousel
                    v-if="specialist.length > 0"
                    indicator-position="outside"
                    style="width: 100%; overflow-x: clip"
                    :height="height"
                >
                    <el-carousel-item
                        v-for="(list, index) in specialist"
                        :key="index"
                        class="zjjs_tt"
                    >
                        <div
                            class="zjjs_b"
                            v-for="(item, index2) in list"
                            ::key="item.index2"
                            @click="toyisheng(item.id)"
                        >
                            <div class="zjjsimg"><img :src="item.photoUrl" alt="" /></div>
                            <div class="name">{{ item.name }}</div>
                            <div class="zc">
                                <p>职称:{{ item.title }}</p>
                                <p>科室:{{ item.department }}</p>
                            </div>
                            <!-- <div class="zjjstext">
                                {{ item.description }}
                            </div> -->
                        </div>
                    </el-carousel-item>
                </el-carousel>
                <div
                    style="
                        height: 500px;
                        text-align: center;
                        line-height: 500px;
                        font-size: 40px;
                        color: #279f99;
                    "
                    v-else
                >
                    暂无数据
                </div>
            </div>
        </div>
        <!-- <div class="ztzl">
            <div class="home_title">
                <div class="title">专题专栏</div>
                <div class="ckgd" @click="tolist(10, 51)">+查看更多</div>
            </div>
            <slideshow :list="ztzlimg"></slideshow>
        </div> -->
        <bott></bott>
    </div>
</template>

<script>
import bott from '@/components/bottom.vue';
import slideshow from '../components/slideshowimg.vue';
export default {
    components: {
        slideshow,
        bott,
    },
    data() {
        return {
            imglist: [],
            ks: '',
            kslist: [],
            synopsis: '',
            synopsisimg: '',
            dynamic: [],
            dynamicimg: '',
            newslist: [],
            notice: [],
            specialist: [],
            ztzlimg: [],
            height: '1200px', //专家轮播图高度
            screenWidth: '',
            ny: '',
            icon: '',
        };
    },
    created() {
        this.list();
    },
    mounted() {
        this.screenWidth = document.body.clientWidth;
        if (document.body.clientWidth < 1200) {
            this.ny = 'font-size: 16px;';
            this.icon = 'font-size: 26px;';
        }
    },
    methods: {
        list() {
            //轮播图
            this.$http
                .get('carousel/selectByStartEnd', {
                    params: {
                        start: 0,
                        end: 10,
                    },
                })
                .then(res => {
                    this.imglist = res.carousels;
                    // console.log('1', res);
                });
            //新闻
            this.$http
                .get('news/selectByCategory', {
                    params: {
                        start: 0,
                        end: 4,
                        categoryId: 17,
                    },
                })
                .then(res => {
                    this.newslist = res.data.contents;
                    // console.log(res);
                });
            //医院概况
            this.$http
                .get('news/selectByCategory', {
                    params: {
                        start: 0,
                        end: 1,
                        categoryId: 11,
                    },
                })
                .then(res => {
                    // console.log('医院概况', res);
                    //去除富文本中的所有html
                    this.synopsis = res.data.contents[0].content.replace(/<[^>]+>/g, '');
                    this.synopsisimg = res.data.contents[0].coverUrl;
                });
            //行业新闻
            this.$http
                .get('news/selectByCategory', {
                    params: {
                        start: 0,
                        end: 5,
                        categoryId: 19,
                    },
                })
                .then(res => {
                    this.dynamic = res.data.contents;
                    this.dynamicimg = res.data.contents[0].coverUrl;
                    // console.log('医院动态', this.dynamic);
                });
            //公告
            this.$http
                .get('news/selectByCategory', {
                    params: {
                        start: 0,
                        end: 6,
                        categoryId: 36,
                    },
                })
                .then(res => {
                    this.notice = res.data.contents;
                    // console.log('公告', this.notice);
                });
            //科室
            this.$http.get('department/selectAll').then(res => {
                // console.log('科室', res);
                this.kslist = res.departmentAll;
            });
            //专题专栏
            this.$http
                .get('news/selectByCategory', {
                    params: {
                        start: 0,
                        end: 7,
                        categoryId: 51,
                    },
                })
                .then(res => {
                    let list = res.data.contents;
                    for (let i = 0; i < list.length; i++) {
                        this.ztzlimg.push({
                            cover: list[i].coverUrl,
                            id: list[i].id,
                            index: i + 1,
                        });
                    }
                    // console.log('专题专栏', res);
                });
            this.zjlist();
        },
        zjlist() {
            //专家
            this.$http
                .get('doctorInfo/selectByStartEnd', {
                    params: {
                        start: 0,
                        end: 10000,
                    },
                })
                .then(res => {
                    // console.log(res);
                    let list = res.doctorInfoS;
                    let newDataList = [];
                    let current = 0;
                    if (list && list.length > 0) {
                        for (let i = 0; i <= list.length - 1; i++) {
                            if (i % 8 !== 0 || i === 0) {
                                if (!newDataList[current]) {
                                    newDataList.push([list[i]]);
                                } else {
                                    newDataList[current].push(list[i]);
                                }
                            } else {
                                current++;
                                newDataList.push([list[i]]);
                            }
                        }
                    }
                    if (list.length <= 4) {
                        this.height = '500px';
                    } else {
                        this.height = '1000px';
                    }
                    this.specialist = [...newDataList];
                    // console.log('专家', this.specialist);
                });
        },
        btnzj() {
            // console.log(this.ks);
            if (this.ks == '') {
                this.zjlist();
            } else {
                this.$http
                    .get('doctorInfo/selectByDepartment', {
                        params: {
                            departmentId: this.ks,
                            start: 1,
                            end: 1000,
                        },
                    })
                    .then(res => {
                        let list = res.doctorInfos;
                        // console.log(res);
                        let newDataList = [];
                        let current = 0;
                        if (list && list.length > 0) {
                            for (let i = 0; i <= list.length - 1; i++) {
                                if (i % 8 !== 0 || i === 0) {
                                    if (!newDataList[current]) {
                                        newDataList.push([list[i]]);
                                    } else {
                                        newDataList[current].push(list[i]);
                                    }
                                } else {
                                    current++;
                                    newDataList.push([list[i]]);
                                }
                            }
                        }
                        if (list.length <= 4) {
                            this.height = '600px';
                        } else {
                            this.height = '1200px';
                        }
                        this.specialist = [...newDataList];
                        // console.log('专家', this.specialist);
                    });
            }
        },
        todetails(id) {
            this.$router.push('/details?id=' + id);
        },
        toyisheng(id) {
            this.$router.push('/yisheng?id=' + id);
        },

        tolist(id, news) {
            // console.log(id, news);
            this.$router.push('/list?id=' + id + '&news=' + news);
        },
        map() {
            this.$router.push('/map/');
        },
        experts() {
            // console.log(11);
            this.$router.push('/experts/');
        },
    },
};
</script>

<style lang="less">
.home {
    img {
        width: 100%;
        height: 100%;
    }
    width: 100%;
    height: 100%;
    .home_lbt {
        width: 100%;
        height: 800px;
    }
    .home_navigation {
        width: 70%;
        height: 191px;
        line-height: 95.5px;
        background-color: #fafafa;
        box-shadow: 0px 0px 13px 0px rgba(32, 32, 32, 0.3);
        opacity: 0.8;
        display: flex;
        justify-content: space-around;
        margin-left: 15%;
        margin-top: -191px;
        position: absolute;
        z-index: 100;
        cursor: pointer;
        div {
            width: 15%;
            text-align: center;
            white-space: nowrap;
            i {
                color: #279f99;
                font-size: 60px;
                font-weight: 700;
            }
            p {
                font-family: SourceHanSansSC-Medium;
                font-size: 30px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 67px;
                letter-spacing: 1px;
                color: #279f99;
            }
            &:hover {
                background-color: #279f99;
                opacity: 1;
                i {
                    color: #fff;
                }
                p {
                    color: #fff;
                }
            }
        }
    }
    .nav {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 100%;
        height: 98px;
        background-color: #e5f3fe;
        margin-top: 10px;
        div {
            font-family: SourceHanSansSC-Regular;
            font-size: 28px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #282828;
            cursor: pointer;
            white-space: nowrap;
        }
    }
    .gkdt {
        width: 95%;
        margin: auto;
        display: flex;
        justify-content: space-between;
        margin-top: 30px;
        margin-bottom: 30px;

        .yygkbox {
            display: flex;
            height: 350px;
            margin-top: 30px;
            box-shadow: 0px 4px 8px 0px rgba(32, 32, 32, 0.14);
            align-items: center;
            padding: 10px;
            .yygkimg {
                width: 50%;
                height: 296px;
                cursor: pointer;
            }
            .yygktext {
                width: 50%;
                height: 296px;
                overflow: hidden;
                font-family: SourceHanSansSC-Regular;
                font-size: 20px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 40px;
                letter-spacing: 0px;
                color: #4d4d4d;
                padding: 8px;
                text-align: justify;
                text-indent: 2em;
                cursor: pointer;
            }
        }
        .yydtbox {
            display: flex;
            height: 350px;
            margin-top: 30px;
            box-shadow: 0px 4px 8px 0px rgba(32, 32, 32, 0.14);
            align-items: center;
            padding: 10px;
            .yydtimg {
                width: 50%;
                height: 296px;
                cursor: pointer;
            }
            .yydttext {
                width: 50%;
                height: 296px;
                cursor: pointer;
                .ul {
                    display: flex;
                    justify-content: space-around;
                    line-height: 60px;
                    font-size: 20px;
                    .ultitle {
                        width: 70%;
                        white-space: nowrap;
                        overflow: hidden;
                    }
                    .ulitem {
                        width: 26%;
                        white-space: nowrap;
                        overflow: hidden;
                    }
                }
            }
        }
    }
    .yygg {
        width: 100%;
        margin: auto;
        height: 695px;
        background-color: #f2f9ff;

        .yygg_b {
            width: 100%;
            padding: 0 2.5%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
        }
        .yyggbox {
            width: 30%;
            height: 201px;
            background-color: #ffffff;
            box-shadow: 0px 4px 8px 0px rgba(32, 32, 32, 0.14);
            margin: 30px 0 0 30px;
            display: flex;
            justify-content: space-around;
            padding: 20px;
            cursor: pointer;
            .timebox {
                width: 25%;
                height: 140px;
                background: url('@/Img/3.png');
                background-size: 100% 100%;
                background-position: center;
                background-repeat: no-repeat;
                .ny {
                    font-family: SourceHanSansSC-Medium;
                    font-size: 24px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 1px;
                    color: #279f99;
                    margin-top: 50px;
                    text-align: center;
                }
                .r {
                    font-family: SourceHanSansSC-Bold;
                    font-size: 32px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 1px;
                    color: #279f99;
                    text-align: center;
                }
            }
            .text_box {
                width: 70%;
                p {
                    -webkit-line-clamp: 2;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    font-family: SourceHanSansSC-Regular;
                    font-size: 24px;
                    font-weight: normal;
                    font-stretch: normal;
                    line-height: 40px;
                    letter-spacing: 1px;
                    color: #7d908f;
                    height: 125px;
                }
                .text_ti {
                    display: flex;
                    flex-direction: row-reverse;
                    align-items: center;

                    p {
                        font-size: 21px;
                        font-weight: normal;
                        font-stretch: normal;
                        letter-spacing: 1px;
                        color: #279f99;
                        overflow: hidden;
                        white-space: nowrap;
                    }
                    i {
                        margin-top: -68px;
                        transform: rotate(270deg);
                        -ms-transform: rotate(270deg);
                        /* Internet Explorer 9*/
                        -moz-transform: rotate(270deg);
                        /* Firefox */
                        -webkit-transform: rotate(270deg);
                        /* Safari 和 Chrome */
                        -o-transform: rotate(270deg);
                        font-size: 26px;
                        color: #279f99;
                    }
                }
            }
        }
    }
    .xwzx {
        width: 100%;
        margin: auto;
        height: 695px;
        background-color: #f3f3f3;

        .xwzx_box {
            width: 100%;
            display: flex;
            justify-content: space-around;
            margin-top: 50px;
            .xwzx_b {
                cursor: pointer;
                width: 20%;
                height: 415px;
                background-color: #ffffff;
                box-shadow: 0px 4px 8px 0px rgba(32, 32, 32, 0.14);
                .xwzx_img {
                    box-shadow: 0px 4px 8px 0px rgba(32, 32, 32, 0.14);
                    height: 266px;
                    background-color: #279f99;
                    margin-bottom: 10px;
                }
                .time {
                    width: 90%;
                    margin: auto;
                    color: #279f99;
                    display: flex;
                    justify-content: space-between;
                    i {
                        background-color: #279f99;
                        color: #fff;
                        padding: 10px;
                    }
                }
                p {
                    width: 95%;
                    margin: auto;
                    -webkit-line-clamp: 2;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    font-family: SourceHanSansSC-Regular;
                    font-size: 26px;
                    font-weight: normal;
                    font-stretch: normal;
                    line-height: 40px;
                    letter-spacing: 1px;
                    color: #7d908f;
                }
            }
        }
    }
    .zjjs {
        width: 100%;

        .zjjs_box {
            display: flex;
            justify-content: space-around;
            flex-wrap: wrap;
            .zjjs_tt {
                display: flex;
                justify-content: space-around;
                flex-wrap: wrap;
                margin-top: 50px;
            }
            .zjjs_b {
                margin: 16px 15px;
                width: 20%;
                height: 400px;
                background-color: #ffffff;
                border: solid 1px #279f99;
                box-shadow: 0px 4px 8px 0px rgba(32, 32, 32, 0.14);
                .zjjsimg {
                    width: 167px;
                    height: 209px;
                    background-color: #cfcfcf;
                    margin: auto;
                    margin-top: 37px;
                }
                .name {
                    width: 100%;
                    text-align: center;
                    font-family: SourceHanSansSC-Medium;
                    font-size: 35px;
                    font-weight: normal;
                    font-stretch: normal;
                    line-height: 67px;
                    letter-spacing: 1px;
                    color: #279f99;
                }
                .zc {
                    font-family: SourceHanSansSC-Medium;
                    font-size: 20px;
                    font-weight: normal;
                    font-stretch: normal;

                    letter-spacing: 1px;
                    color: #279f99;
                    display: flex;
                    justify-content: space-around;
                }
                @media screen and (max-width: 750px) {
                    .zc {
                        font-size: 12px;
                    }
                }
                .zjjstext {
                    width: 95%;
                    margin: auto;
                    border-top: 1px solid #ccc;
                    font-family: SourceHanSansSC-Normal;
                    font-size: 20px;
                    font-weight: normal;
                    font-stretch: normal;
                    line-height: 30px;
                    letter-spacing: 1px;
                    color: #879191;
                    -webkit-line-clamp: 4;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding-top: 10px;
                }
            }
        }
    }

    .home_title {
        width: 90%;
        padding: 30px 0;
        margin: auto;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title {
            font-family: SourceHanSansSC-Bold;
            font-size: 65px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 67px;
            letter-spacing: 3px;
            color: #279f99;
            white-space: nowrap;
        }
        .ckgd {
            white-space: nowrap;
            font-family: SourceHanSansSC-Regular;
            font-size: 30px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 67px;
            letter-spacing: 1px;
            color: #279f99;
            cursor: pointer;
            display: flex;
            align-items: center;
        }
    }
}
</style>
